/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type EnumBillingTransactionExternalIdSource = "instamed" | "paypal" | "salucro" | "%future added value";
export type QuestionCopayExternalIdQueryVariables = {
    id: string;
    externalId?: string | null | undefined;
};
export type QuestionCopayExternalIdQueryResponse = {
    readonly billingTransactionOne: {
        readonly _id: string;
        readonly amount: number | null;
        readonly externalId: {
            readonly source: EnumBillingTransactionExternalIdSource | null;
            readonly value: string | null;
        } | null;
        readonly externalLink: string | null;
        readonly createdAt: unknown | null;
        readonly status: string | null;
        readonly billingCopay: {
            readonly name: string | null;
        } | null;
    } | null;
};
export type QuestionCopayExternalIdQuery = {
    readonly response: QuestionCopayExternalIdQueryResponse;
    readonly variables: QuestionCopayExternalIdQueryVariables;
};



/*
query QuestionCopayExternalIdQuery(
  $id: MongoID!
  $externalId: String
) {
  billingTransactionOne(filter: {patientForm: $id, externalId: {value: $externalId}}) {
    _id
    amount
    externalId {
      source
      value
    }
    externalLink
    createdAt
    status
    billingCopay {
      name
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "externalId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "value",
            "variableName": "externalId"
          }
        ],
        "kind": "ObjectValue",
        "name": "externalId"
      },
      {
        "kind": "Variable",
        "name": "patientForm",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "BillingTransactionExternalId",
  "kind": "LinkedField",
  "name": "externalId",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalLink",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "QuestionCopayExternalIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BillingTransaction",
        "kind": "LinkedField",
        "name": "billingTransactionOne",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingCopay",
            "kind": "LinkedField",
            "name": "billingCopay",
            "plural": false,
            "selections": [
              (v9/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "QuestionCopayExternalIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "BillingTransaction",
        "kind": "LinkedField",
        "name": "billingTransactionOne",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingCopay",
            "kind": "LinkedField",
            "name": "billingCopay",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2b44416d84c57753e6389b5a256e01dc",
    "id": null,
    "metadata": {},
    "name": "QuestionCopayExternalIdQuery",
    "operationKind": "query",
    "text": "query QuestionCopayExternalIdQuery(\n  $id: MongoID!\n  $externalId: String\n) {\n  billingTransactionOne(filter: {patientForm: $id, externalId: {value: $externalId}}) {\n    _id\n    amount\n    externalId {\n      source\n      value\n    }\n    externalLink\n    createdAt\n    status\n    billingCopay {\n      name\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '917e7a7c686d5e75c96998a095e55dec';
export default node;
